<template>
  <div>
    <modalDefaultBig
      :showModal="showModal"
      @close="close()"
      @confirm="confirm()"
      modalText="十佳掉落"
      :showCancel="false"
      :showConfirm="false"
    >
      <template #dialogContent>
        <div class="ten-content">
          <div class="data-item" v-for="(item, index) in lists" :key="index">
            <div class="data-content">
              <div class="user-avatar">
                <img
                  v-if="item.userAvatar"
                  :src="$getFullPath(item.userAvatar)"
                  mode="aspectFit"
                />
                <img
                  v-else
                  :src="defaultHeader"
                  mode="aspectFit"
                />
                <div class="avatar-bg"></div>
              </div>
              <div class="ratio-main">
                <div class="ratio text-font">
                  {{ item.probability || 0.0 }}%
                </div>
                <div class="price">
                  <img
                    src="../../assets/images/balance2.png"
                    alt=""
                    mode="aspectFit"
                  />
                  <span>{{ item.amountConsumed }}</span>
                </div>
              </div>
              <div class="col">
                <div class="ratio text-font text-ellipsis">
                  {{ item.ornamentList.ornamentName }}
                </div>
                <div class="price">
                  <img
                    src="../../assets/images/balance2.png"
                    alt=""
                    mode="aspectFit"
                  />
                  <span>{{ item.gainOrnamentsPrice }}</span>
                </div>
              </div>

              <img
                    :src="$getFullPath(item.ornamentList.ornamentImgUrl) "
                    alt=""
                     class="gun-col"
                    mode="aspectFit"
                  />
            </div>
            <div class="data-footer">
              <div class="nickname text-ellipsis">{{ item.nickName }}</div>
              <div class="time">{{ item.openTime }}</div>
            </div>
          </div>
        </div>
      </template>
      <template #bottomTab> </template>
    </modalDefaultBig>
  </div>
</template>
<script>
import modalDefaultBig from "@/components/common/modalDefaultBig.vue";
import { tenTopUpgradeRecord } from "@/api/index";
export default {
  name: "modalRecordsLuckyTen",
  components: {
    modalDefaultBig,
  },
  data() {
    return {
      lists: [],
      defaultHeader: require("../../assets/images/default-header.png"),
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    confirm() {
      this.$emit("confirm");
    },
    init() {
      this.getLists();
    },
    getLists() {
      tenTopUpgradeRecord({ isVictory: true }).then((res) => {
        if (res.data.code == 200) {
          this.lists = res.data.data.records;
          this.lists.forEach((item) => {
            item.ornamentList = JSON.parse(item.gainOrnamentList)[0];
          });
          console.log(this.lists, "测试数据");
        } else {
          this.$message({ duration: 1000,
            message: res.data.msg,
            type: "warning",
            customClass: "log_warning",
          });
          return;
        }
      });
    },
  },
};
</script>
  <style scoped lang="scss">
.ten-content {
  margin: 2.13 * 4.2px 4.53 * 4.2px 6.67 * 4.2px 4.53 * 4.2px;
  height: 106.67 * 4.2px;
  overflow: hidden;
  overflow-y: auto;
}
.ten-content .data-item {
  width: 91.07 * 4.2px;
  height: 19.33 * 4.2px;
  background: url("../../assets/images/record-bg.png") no-repeat;
  background-size: 91.07 * 4.2px 19.33 * 4.2px;
  margin-bottom: 1.87 * 4.2px;
}
.ten-content .data-item .data-content {
  padding: 3.87 * 4.2px 2 * 4.2px 0 7.2 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.ten-content .data-item .data-content div {
  font-size: 3.33 * 4.2px;
}
.ten-content .data-item .data-content .text-font {
  color: #e6b4ff;
}
.ten-content .data-item .data-content .price {
  margin-top: 0.67 * 4.2px;
  color: #ffffff;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}
.ten-content .data-item .data-content .price img {
  width: 4 * 4.2px;
  height: 4 * 4.2px;
  margin-right: 1.07 * 4.2px;
  margin-top: -0.67 * 4.2px;
}
.ten-content .data-item .data-content .user-avatar {
  width: 10.67 * 4.2px;
  height: 10.67 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 3.2 * 4.2px;
  position: relative;
}
.ten-content .data-item .data-content .user-avatar img {
  width: 10.67 * 4.2px;
  height: 10.67 * 4.2px;
  -webkit-border-radius: 3.2 * 4.2px;
  border-radius: 50%;
}
.ten-content .data-item .data-content .user-avatar .avatar-bg {
  width: 10.67 * 4.2px;
  height: 10.67 * 4.2px;
  overflow: hidden;
  background: url("../../assets/images/avatar-bg.png") no-repeat 0 0;
  background-size: 10.67 * 4.2px 10.67 * 4.2px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
}
.ten-content .data-item .data-content .ratio-main {
  margin-left: 2.67 * 4.2px;
  width: 18 * 4.2px;
  white-space: nowrap;
  text-align: right;
}
.ten-content .data-item .data-content .ratio-main .ratio {
  padding-right: 1.33 * 4.2px;
}
.ten-content .data-item .data-content .col {
  margin-left: 4 * 4.2px;
  width: 30 * 4.2px;
  white-space: nowrap;
  text-align: right;
}
.ten-content .data-item .data-content .col .price {
  padding-right: 4 * 4.2px;
}
.ten-content .data-item .data-content .gun-col {
  width: 16 * 4.2px;
  height: 10.67 * 4.2px;
  -o-object-fit: cover;
  object-fit: cover;
}
.ten-content .data-item .data-footer {
  margin-top: 0.53 * 4.2px;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-left: 4 * 4.2px;
  padding-right: 7.47 * 4.2px;
  font-size: 2.67 * 4.2px;
  color: #e6b4ff;
}
.ten-content .data-item .data-footer .nickname {
  text-align: center;
  width: 18.67 * 4.2px;
}
.ten-content .empty-view {
  margin-top: 30%;
}
@media only screen and (max-width: 430px) {
  .ten-content {
    margin: 2.13vw 4.53vw 6.67vw 4.53vw;
    height: 106.67vw;
  }
  .ten-content .data-item {
    width: 91.07vw;
    height: 19.33vw;
    background-size: 91.07vw 19.33vw;
    margin-bottom: 1.87vw;
  }
  .ten-content .data-item .data-content {
    padding: 3.87vw 2vw 0 7.2vw;
  }
  .ten-content .data-item .data-content div {
    font-size: 3.33vw;
  }

  .ten-content .data-item .data-content .price {
    margin-top: 0.67vw;
  }
  .ten-content .data-item .data-content .price img {
    width: 4vw;
    height: 4vw;
    margin-right: 1.07vw;
    margin-top: -0.67vw;
  }
  .ten-content .data-item .data-content .user-avatar {
    width: 10.67vw;
    height: 10.67vw;
    -webkit-border-radius: 3.2vw;
    border-radius: 3.2vw;
  }
  .ten-content .data-item .data-content .user-avatar img {
    width: 10.67vw;
    height: 10.67vw;
    -webkit-border-radius: 3.2vw;
  }
  .ten-content .data-item .data-content .user-avatar .avatar-bg {
    width: 10.67vw;
    height: 10.67vw;

    background-size: 10.67vw 10.67vw;
  }
  .ten-content .data-item .data-content .ratio-main {
    margin-left: 2.67vw;
    width: 18vw;
  }
  .ten-content .data-item .data-content .ratio-main .ratio {
    padding-right: 1.33vw;
  }
  .ten-content .data-item .data-content .col {
    margin-left: 4vw;
    width: 30vw;
  }
  .ten-content .data-item .data-content .col .price {
    padding-right: 4vw;
  }
  .ten-content .data-item .data-content .gun-col {
    width: 16vw;
    height: 10.67vw;
  }
  .ten-content .data-item .data-footer {
    margin-top: 0.53vw;

    padding-left: 4vw;
    padding-right: 7.47vw;
    font-size: 2.67vw;
  }
  .ten-content .data-item .data-footer .nickname {
    width: 18.67vw;
  }
  .ten-content .empty-view {
    margin-top: 30%;
  }
}
</style>